import React from 'react';

export const ManningsPairImage = () => {
  return (
    <svg width="516" height="278" viewBox="0 0 516 278" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3346_193067)">
        <rect width="516" height="278" fill="white" />
        <path d="M403 129L403 207" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path d="M403 19L403 97" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path
          d="M402.82 107.27V117H401.224V112.744H396.646V117H395.05V107.27H396.646V111.442H401.224V107.27H402.82ZM405.593 114.83C406.489 114.055 407.194 113.421 407.707 112.926C408.23 112.422 408.664 111.899 409.009 111.358C409.354 110.817 409.527 110.275 409.527 109.734C409.527 109.174 409.392 108.735 409.121 108.418C408.86 108.101 408.444 107.942 407.875 107.942C407.324 107.942 406.895 108.119 406.587 108.474C406.288 108.819 406.13 109.286 406.111 109.874H404.571C404.599 108.81 404.916 107.998 405.523 107.438C406.139 106.869 406.918 106.584 407.861 106.584C408.878 106.584 409.672 106.864 410.241 107.424C410.82 107.984 411.109 108.731 411.109 109.664C411.109 110.336 410.936 110.985 410.591 111.61C410.255 112.226 409.849 112.781 409.373 113.276C408.906 113.761 408.309 114.326 407.581 114.97L406.951 115.53H411.389V116.86H404.585V115.698L405.593 114.83Z"
          fill="#555770"
        />
        <path
          d="M403.551 23.4492L407.67 19.3297C408.161 18.839 407.813 18 407.119 18H398.881C398.187 18 397.839 18.839 398.33 19.3297L402.449 23.4492C402.753 23.7534 403.247 23.7534 403.551 23.4492Z"
          fill="#8F90A6"
        />
        <path
          d="M403.551 202.551L407.67 206.67C408.161 207.161 407.813 208 407.119 208H398.881C398.187 208 397.839 207.161 398.33 206.67L402.449 202.551C402.753 202.247 403.247 202.247 403.551 202.551Z"
          fill="#8F90A6"
        />
        <path
          d="M380.554 19.14H299.954C298.706 19.14 297.694 20.1518 297.694 21.4V204.6C297.694 205.848 298.706 206.86 299.954 206.86H380.554C381.802 206.86 382.814 205.848 382.814 204.6V21.4C382.814 20.1518 381.802 19.14 380.554 19.14Z"
          fill="#F9F9FA"
        />
        <mask
          id="mask0_3346_193067"
          // style="mask-type:alpha"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="298"
          y="24"
          width="84"
          height="182"
        >
          <path
            d="M381.674 24.0801H298.834V204.58C298.834 205.21 299.345 205.72 299.974 205.72H380.534C381.164 205.72 381.674 205.21 381.674 204.58V24.0801Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_3346_193067)">
          <g filter="url(#filter0_i_3346_193067)">
            <path
              d="M298.834 205.721H381.674C381.674 202.66 381.674 112.124 381.674 107.321C348.171 118.959 343.911 105.458 324.139 103.996C312.569 103.141 298.834 107.321 298.834 107.321C298.834 107.321 298.834 203.844 298.834 205.721Z"
              fill="url(#paint0_linear_3346_193067)"
            />
          </g>
        </g>
        <g filter="url(#filter1_i_3346_193067)">
          <rect width="87.4" height="5.32" rx="1.52" transform="matrix(-1 0 0 1 383.954 18)" fill="#8F90A6" />
        </g>
        <path
          d="M380.554 19.14H299.954C298.706 19.14 297.694 20.1518 297.694 21.4V204.6C297.694 205.848 298.706 206.86 299.954 206.86H380.554C381.802 206.86 382.814 205.848 382.814 204.6V21.4C382.814 20.1518 381.802 19.14 380.554 19.14Z"
          stroke="#F2F2F5"
          stroke-width="2.28"
        />
        <rect
          x="-1.14"
          y="1.14"
          width="85.1201"
          height="187.72"
          rx="2.26"
          transform="matrix(-1 0 0 1 216.066 18)"
          fill="#F9F9FA"
        />
        <mask
          id="mask1_3346_193067"
          // style="mask-type:alpha"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="133"
          y="24"
          width="84"
          height="182"
        >
          <path
            d="M216.066 24.0801H133.226V204.58C133.226 205.21 133.736 205.72 134.366 205.72H214.926C215.556 205.72 216.066 205.21 216.066 204.58V24.0801Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask1_3346_193067)">
          <g filter="url(#filter2_i_3346_193067)">
            <path
              d="M133.226 205.721H216.066C216.066 202.66 216.066 112.124 216.066 107.321C182.562 118.959 178.302 105.458 158.53 103.996C146.961 103.141 133.226 107.321 133.226 107.321C133.226 107.321 133.226 203.844 133.226 205.721Z"
              fill="url(#paint1_linear_3346_193067)"
            />
          </g>
        </g>
        <g filter="url(#filter3_i_3346_193067)">
          <rect width="87.4" height="5.32" rx="1.52" transform="matrix(-1 0 0 1 218.346 18)" fill="#8F90A6" />
        </g>
        <rect
          x="-1.14"
          y="1.14"
          width="85.1201"
          height="187.72"
          rx="2.26"
          transform="matrix(-1 0 0 1 216.066 18)"
          stroke="#F2F2F5"
          stroke-width="2.28"
        />
        <path
          d="M296.685 104.922L218.204 89.0075C218.115 88.9894 218.032 89.0575 218.032 89.1484V118.377C218.032 118.446 218.08 118.505 218.147 118.518L296.628 134.674C296.717 134.693 296.8 134.624 296.8 134.533V105.063C296.8 104.995 296.752 104.936 296.685 104.922Z"
          fill="#F9F9FA"
          stroke="#F2F2F5"
          stroke-width="2.28"
        />
        <path
          d="M297.651 132.086L297.651 105.135L217.214 88.9278V116.489C217.214 117.562 217.968 118.487 219.019 118.703L294.936 134.3C296.337 134.588 297.651 133.517 297.651 132.086Z"
          fill="#F9F9FA"
          stroke="#F2F2F5"
          stroke-width="2.28"
        />
        <mask
          id="mask2_3346_193067"
          // style="mask-type:alpha"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="218"
          y="88"
          width="79"
          height="46"
        >
          <path
            d="M295.413 131.981V105.539L219.381 89.7507V116.43L295.413 131.981Z"
            fill="#F9F9FA"
            stroke="#F2F2F5"
            stroke-width="2.28"
          />
        </mask>
        <g mask="url(#mask2_3346_193067)">
          <g filter="url(#filter4_i_3346_193067)">
            <path
              d="M215.101 205.854H297.941C297.941 202.793 297.941 112.257 297.941 107.454C264.437 119.092 260.177 105.59 240.405 104.129C228.836 103.274 215.101 107.454 215.101 107.454C215.101 107.454 215.101 203.977 215.101 205.854Z"
              fill="url(#paint2_linear_3346_193067)"
            />
          </g>
        </g>
        <path
          d="M247.797 139.391L218.407 133.368"
          stroke="#8F90A6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-dasharray="3 5"
        />
        <path
          d="M295.722 148.945L267.311 143.123"
          stroke="#8F90A6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-dasharray="3 5"
        />
        <path
          d="M293.348 148.449L297.467 144.33C297.958 143.839 298.797 144.187 298.797 144.881V153.119C298.797 153.813 297.958 154.161 297.467 153.67L293.348 149.551C293.043 149.247 293.043 148.753 293.348 148.449Z"
          fill="#8F90A6"
        />
        <path
          d="M221.246 133.551L217.127 137.67C216.636 138.161 215.797 137.813 215.797 137.119V128.881C215.797 128.187 216.636 127.839 217.127 128.33L221.246 132.449C221.55 132.753 221.55 133.247 221.246 133.551Z"
          fill="#8F90A6"
        />
        <rect width="25" height="21" transform="translate(244.797 131)" fill="white" />
        <path
          d="M247.937 146V145.3L251.703 135.962H252.837L256.589 145.3V146H247.937ZM249.379 144.866H255.133L252.795 138.762C252.767 138.687 252.716 138.552 252.641 138.356C252.566 138.16 252.492 137.959 252.417 137.754C252.352 137.539 252.3 137.376 252.263 137.264C252.216 137.451 252.16 137.642 252.095 137.838C252.039 138.025 251.978 138.197 251.913 138.356C251.857 138.515 251.81 138.65 251.773 138.762L249.379 144.866ZM262.254 141.142L265.278 146H263.486L261.288 142.472L259.23 146H257.452L260.476 141.142L257.438 136.27H259.23L261.442 139.826L263.514 136.27H265.292L262.254 141.142Z"
          fill="#555770"
        />
        <path d="M113 129L113 207" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path d="M113 19L113 97" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path
          d="M113.82 107.27V117H112.224V112.744H107.646V117H106.05V107.27H107.646V111.442H112.224V107.27H113.82ZM115.501 108.25V106.794H118.413V117H116.803V108.25H115.501Z"
          fill="#555770"
        />
        <path
          d="M113.551 23.4492L117.67 19.3297C118.161 18.839 117.813 18 117.119 18H108.881C108.187 18 107.839 18.839 108.33 19.3297L112.449 23.4492C112.753 23.7534 113.247 23.7534 113.551 23.4492Z"
          fill="#8F90A6"
        />
        <path
          d="M113.551 202.551L117.67 206.67C118.161 207.161 117.813 208 117.119 208H108.881C108.187 208 107.839 207.161 108.33 206.67L112.449 202.551C112.753 202.247 113.247 202.247 113.551 202.551Z"
          fill="#8F90A6"
        />
        <path d="M341 188L341 206" stroke="#72748E" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path d="M341 138L341 156" stroke="#72748E" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path
          d="M336.992 169.162C337.58 169.162 338.103 169.288 338.56 169.54C339.027 169.792 339.391 170.165 339.652 170.66C339.923 171.155 340.058 171.752 340.058 172.452V177.002H338.476V172.69C338.476 171.999 338.303 171.472 337.958 171.108C337.613 170.735 337.141 170.548 336.544 170.548C335.947 170.548 335.471 170.735 335.116 171.108C334.771 171.472 334.598 171.999 334.598 172.69V177.002H333.002V166.642H334.598V170.184C334.869 169.857 335.209 169.605 335.62 169.428C336.04 169.251 336.497 169.162 336.992 169.162ZM342.766 174.832C343.662 174.057 344.367 173.423 344.88 172.928C345.403 172.424 345.837 171.901 346.182 171.36C346.527 170.819 346.7 170.277 346.7 169.736C346.7 169.176 346.565 168.737 346.294 168.42C346.033 168.103 345.617 167.944 345.048 167.944C344.497 167.944 344.068 168.121 343.76 168.476C343.461 168.821 343.303 169.288 343.284 169.876H341.744C341.772 168.812 342.089 168 342.696 167.44C343.312 166.871 344.091 166.586 345.034 166.586C346.051 166.586 346.845 166.866 347.414 167.426C347.993 167.986 348.282 168.733 348.282 169.666C348.282 170.338 348.109 170.987 347.764 171.612C347.428 172.228 347.022 172.783 346.546 173.278C346.079 173.763 345.482 174.328 344.754 174.972L344.124 175.532H348.562V176.862H341.758V175.7L342.766 174.832Z"
          fill="#555770"
        />
        <path
          d="M341.551 141.451L345.67 137.332C346.161 136.841 345.813 136.002 345.119 136.002H336.881C336.187 136.002 335.839 136.841 336.33 137.332L340.449 141.451C340.753 141.755 341.247 141.755 341.551 141.451Z"
          fill="#72748E"
        />
        <path
          d="M341.551 202.551L345.67 206.67C346.161 207.161 345.813 208 345.119 208H336.881C336.187 208 335.839 207.161 336.33 206.67L340.449 202.551C340.753 202.247 341.247 202.247 341.551 202.551Z"
          fill="#72748E"
        />
        <path
          d="M206.379 89.8906L206.379 107.891"
          stroke="#8F90A6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-dasharray="3 5"
        />
        <path
          d="M189.518 104.108C189.518 103.333 189.677 102.647 189.994 102.05C190.321 101.453 190.759 100.991 191.31 100.664C191.87 100.328 192.491 100.16 193.172 100.16C193.676 100.16 194.171 100.272 194.656 100.496C195.151 100.711 195.543 101 195.832 101.364V97.64H197.442V108H195.832V106.838C195.571 107.211 195.207 107.519 194.74 107.762C194.283 108.005 193.755 108.126 193.158 108.126C192.486 108.126 191.87 107.958 191.31 107.622C190.759 107.277 190.321 106.801 189.994 106.194C189.677 105.578 189.518 104.883 189.518 104.108ZM195.832 104.136C195.832 103.604 195.72 103.142 195.496 102.75C195.281 102.358 194.997 102.059 194.642 101.854C194.287 101.649 193.905 101.546 193.494 101.546C193.083 101.546 192.701 101.649 192.346 101.854C191.991 102.05 191.702 102.344 191.478 102.736C191.263 103.119 191.156 103.576 191.156 104.108C191.156 104.64 191.263 105.107 191.478 105.508C191.702 105.909 191.991 106.217 192.346 106.432C192.71 106.637 193.093 106.74 193.494 106.74C193.905 106.74 194.287 106.637 194.642 106.432C194.997 106.227 195.281 105.928 195.496 105.536C195.72 105.135 195.832 104.668 195.832 104.136Z"
          fill="#555770"
        />
        <path
          d="M206.93 93.3418L211.049 89.2223C211.54 88.7316 211.192 87.8926 210.498 87.8926H202.259C201.565 87.8926 201.218 88.7316 201.709 89.2223L205.828 93.3418C206.132 93.646 206.626 93.646 206.93 93.3418Z"
          fill="#8F90A6"
        />
        <path
          d="M206.93 113.551L211.049 117.67C211.54 118.161 211.192 119 210.498 119H202.259C201.565 119 201.218 118.161 201.709 117.67L205.828 113.551C206.132 113.247 206.626 113.247 206.93 113.551Z"
          fill="#72748E"
        />
        <path
          d="M174 178.891L174 196.891"
          stroke="#72748E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-dasharray="3 5"
        />
        <path
          d="M174 127.891L174 145.891"
          stroke="#72748E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-dasharray="3 5"
        />
        <path
          d="M172.161 160.053C172.749 160.053 173.272 160.179 173.729 160.431C174.196 160.683 174.56 161.056 174.821 161.551C175.092 162.045 175.227 162.643 175.227 163.343V167.893H173.645V163.581C173.645 162.89 173.472 162.363 173.127 161.999C172.782 161.625 172.31 161.439 171.713 161.439C171.116 161.439 170.64 161.625 170.285 161.999C169.94 162.363 169.767 162.89 169.767 163.581V167.893H168.171V157.533H169.767V161.075C170.038 160.748 170.378 160.496 170.789 160.319C171.209 160.141 171.666 160.053 172.161 160.053ZM176.843 159.143V157.687H179.755V167.893H178.145V159.143H176.843Z"
          fill="#555770"
        />
        <path
          d="M174.551 123.342L178.67 119.222C179.161 118.732 178.813 117.893 178.119 117.893H169.881C169.187 117.893 168.839 118.732 169.33 119.222L173.449 123.342C173.753 123.646 174.247 123.646 174.551 123.342Z"
          fill="#72748E"
        />
        <path
          d="M174.551 202.551L178.67 206.67C179.161 207.161 178.813 208 178.119 208H169.881C169.187 208 168.839 207.161 169.33 206.67L173.449 202.551C173.753 202.247 174.247 202.247 174.551 202.551Z"
          fill="#72748E"
        />
        <path d="M36 146L36 241" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path d="M36 19L36 114" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path
          d="M31.298 124.27V134H29.702V127.336L26.734 134H25.628L22.646 127.336V134H21.05V124.27H22.772L26.188 131.9L29.59 124.27H31.298ZM36.6017 134.098C35.9484 134.098 35.3604 133.986 34.8377 133.762C34.315 133.529 33.9044 133.202 33.6057 132.782C33.307 132.362 33.1577 131.872 33.1577 131.312H34.8657C34.903 131.732 35.0664 132.077 35.3557 132.348C35.6544 132.619 36.0697 132.754 36.6017 132.754C37.1524 132.754 37.5817 132.623 37.8897 132.362C38.1977 132.091 38.3517 131.746 38.3517 131.326C38.3517 130.999 38.2537 130.733 38.0577 130.528C37.871 130.323 37.633 130.164 37.3437 130.052C37.0637 129.94 36.6717 129.819 36.1677 129.688C35.533 129.52 35.015 129.352 34.6137 129.184C34.2217 129.007 33.8857 128.736 33.6057 128.372C33.3257 128.008 33.1857 127.523 33.1857 126.916C33.1857 126.356 33.3257 125.866 33.6057 125.446C33.8857 125.026 34.2777 124.704 34.7817 124.48C35.2857 124.256 35.869 124.144 36.5317 124.144C37.4744 124.144 38.2444 124.382 38.8417 124.858C39.4484 125.325 39.7844 125.969 39.8497 126.79H38.0857C38.0577 126.435 37.8897 126.132 37.5817 125.88C37.2737 125.628 36.8677 125.502 36.3637 125.502C35.9064 125.502 35.533 125.619 35.2437 125.852C34.9544 126.085 34.8097 126.421 34.8097 126.86C34.8097 127.159 34.8984 127.406 35.0757 127.602C35.2624 127.789 35.4957 127.938 35.7757 128.05C36.0557 128.162 36.4384 128.283 36.9237 128.414C37.5677 128.591 38.0904 128.769 38.4917 128.946C38.9024 129.123 39.2477 129.399 39.5277 129.772C39.817 130.136 39.9617 130.626 39.9617 131.242C39.9617 131.737 39.8264 132.203 39.5557 132.642C39.2944 133.081 38.907 133.435 38.3937 133.706C37.8897 133.967 37.2924 134.098 36.6017 134.098ZM43.4409 132.712H46.7309V134H41.8449V124.27H43.4409V132.712ZM47.6456 125.25V123.794H50.5576V134H48.9476V125.25H47.6456Z"
          fill="#555770"
        />
        <path
          d="M36.5508 23.4492L40.6703 19.3297C41.161 18.839 40.8134 18 40.1195 18H31.8805C31.1866 18 30.839 18.839 31.3297 19.3297L35.4492 23.4492C35.7534 23.7534 36.2466 23.7534 36.5508 23.4492Z"
          fill="#8F90A6"
        />
        <path
          d="M36.5508 236.551L40.6703 240.67C41.161 241.161 40.8134 242 40.1195 242H31.8805C31.1866 242 30.839 241.161 31.3297 240.67L35.4492 236.551C35.7534 236.247 36.2466 236.247 36.5508 236.551Z"
          fill="#8F90A6"
        />
        <path d="M480 146L480 241" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path d="M480 19L480 114" stroke="#8F90A6" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <path
          d="M473.298 124.27V134H471.702V127.336L468.734 134H467.628L464.646 127.336V134H463.05V124.27H464.772L468.188 131.9L471.59 124.27H473.298ZM478.602 134.098C477.948 134.098 477.36 133.986 476.838 133.762C476.315 133.529 475.904 133.202 475.606 132.782C475.307 132.362 475.158 131.872 475.158 131.312H476.866C476.903 131.732 477.066 132.077 477.356 132.348C477.654 132.619 478.07 132.754 478.602 132.754C479.152 132.754 479.582 132.623 479.89 132.362C480.198 132.091 480.352 131.746 480.352 131.326C480.352 130.999 480.254 130.733 480.058 130.528C479.871 130.323 479.633 130.164 479.344 130.052C479.064 129.94 478.672 129.819 478.168 129.688C477.533 129.52 477.015 129.352 476.614 129.184C476.222 129.007 475.886 128.736 475.606 128.372C475.326 128.008 475.186 127.523 475.186 126.916C475.186 126.356 475.326 125.866 475.606 125.446C475.886 125.026 476.278 124.704 476.782 124.48C477.286 124.256 477.869 124.144 478.532 124.144C479.474 124.144 480.244 124.382 480.842 124.858C481.448 125.325 481.784 125.969 481.85 126.79H480.086C480.058 126.435 479.89 126.132 479.582 125.88C479.274 125.628 478.868 125.502 478.364 125.502C477.906 125.502 477.533 125.619 477.244 125.852C476.954 126.085 476.81 126.421 476.81 126.86C476.81 127.159 476.898 127.406 477.076 127.602C477.262 127.789 477.496 127.938 477.776 128.05C478.056 128.162 478.438 128.283 478.924 128.414C479.568 128.591 480.09 128.769 480.492 128.946C480.902 129.123 481.248 129.399 481.528 129.772C481.817 130.136 481.962 130.626 481.962 131.242C481.962 131.737 481.826 132.203 481.556 132.642C481.294 133.081 480.907 133.435 480.394 133.706C479.89 133.967 479.292 134.098 478.602 134.098ZM485.441 132.712H488.731V134H483.845V124.27H485.441V132.712ZM490.738 131.83C491.634 131.055 492.338 130.421 492.852 129.926C493.374 129.422 493.808 128.899 494.154 128.358C494.499 127.817 494.672 127.275 494.672 126.734C494.672 126.174 494.536 125.735 494.266 125.418C494.004 125.101 493.589 124.942 493.02 124.942C492.469 124.942 492.04 125.119 491.732 125.474C491.433 125.819 491.274 126.286 491.256 126.874H489.716C489.744 125.81 490.061 124.998 490.668 124.438C491.284 123.869 492.063 123.584 493.006 123.584C494.023 123.584 494.816 123.864 495.386 124.424C495.964 124.984 496.254 125.731 496.254 126.664C496.254 127.336 496.081 127.985 495.736 128.61C495.4 129.226 494.994 129.781 494.518 130.276C494.051 130.761 493.454 131.326 492.726 131.97L492.096 132.53H496.534V133.86H489.73V132.698L490.738 131.83Z"
          fill="#555770"
        />
        <path
          d="M480.551 23.4492L484.67 19.3297C485.161 18.839 484.813 18 484.119 18H475.881C475.187 18 474.839 18.839 475.33 19.3297L479.449 23.4492C479.753 23.7534 480.247 23.7534 480.551 23.4492Z"
          fill="#8F90A6"
        />
        <path
          d="M480.551 236.551L484.67 240.67C485.161 241.161 484.813 242 484.119 242H475.881C475.187 242 474.839 241.161 475.33 240.67L479.449 236.551C479.753 236.247 480.247 236.247 480.551 236.551Z"
          fill="#8F90A6"
        />
        <g clip-path="url(#clip1_3346_193067)">
          <path
            d="M-36.867 301.34C-141.323 289.557 -43.0114 250.645 -36.867 242.647C-30.7225 234.649 -12.2892 253.351 -0.000320435 253.351C12.2886 253.351 24.5775 242.647 36.8663 242.647C49.1552 242.647 61.4441 253.351 73.733 253.351C86.0219 253.351 98.3108 242.647 110.6 242.647C122.889 242.647 135.177 253.351 147.466 253.351C159.755 253.351 172.044 242.647 184.333 242.647C196.622 242.647 208.911 253.351 221.2 253.351C233.489 253.351 245.777 242.647 258.066 242.647C270.355 242.647 282.644 253.351 294.933 253.351C307.222 253.351 319.511 242.647 331.8 242.647C344.089 242.647 356.377 253.351 368.666 253.351C380.955 253.351 393.244 242.647 405.533 242.647C417.822 242.647 430.111 253.351 442.4 253.351C454.689 253.351 466.977 242.647 479.266 242.647C491.555 242.647 503.844 253.351 516.133 253.351C528.422 253.351 540.711 242.647 553 242.647C565.289 242.647 583.722 241.569 589.866 253.351C596.011 265.133 694.322 293.341 589.866 301.34"
            fill="url(#paint3_linear_3346_193067)"
          />
          <path
            d="M-36.8662 242.648C-30.7218 246.432 -12.2884 253.352 0.000458541 253.352C12.2893 253.352 24.5782 242.648 36.8671 242.648C49.156 242.648 61.4449 253.352 73.7338 253.352C86.0227 253.352 98.3116 242.648 110.6 242.648C122.889 242.648 135.178 253.352 147.467 253.352C159.756 253.352 172.045 242.648 184.334 242.648C196.623 242.648 208.912 253.352 221.2 253.352C233.489 253.352 245.778 242.648 258.067 242.648C270.356 242.648 282.645 253.352 294.934 253.352C307.223 253.352 319.512 242.648 331.801 242.648C344.089 242.648 356.378 253.352 368.667 253.352C380.956 253.352 393.245 242.648 405.534 242.648C417.823 242.648 430.112 253.352 442.401 253.352C454.689 253.352 466.978 242.648 479.267 242.648C491.556 242.648 503.845 253.352 516.134 253.352C528.423 253.352 540.712 242.648 553.001 242.648C565.289 242.648 583.723 249.568 589.867 253.352"
            stroke="#E1EEFB"
            stroke-width="1.548"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M248.256 268.098C247.603 268.098 247.015 267.986 246.492 267.762C245.969 267.529 245.559 267.202 245.26 266.782C244.961 266.362 244.812 265.872 244.812 265.312H246.52C246.557 265.732 246.721 266.077 247.01 266.348C247.309 266.619 247.724 266.754 248.256 266.754C248.807 266.754 249.236 266.623 249.544 266.362C249.852 266.091 250.006 265.746 250.006 265.326C250.006 264.999 249.908 264.733 249.712 264.528C249.525 264.323 249.287 264.164 248.998 264.052C248.718 263.94 248.326 263.819 247.822 263.688C247.187 263.52 246.669 263.352 246.268 263.184C245.876 263.007 245.54 262.736 245.26 262.372C244.98 262.008 244.84 261.523 244.84 260.916C244.84 260.356 244.98 259.866 245.26 259.446C245.54 259.026 245.932 258.704 246.436 258.48C246.94 258.256 247.523 258.144 248.186 258.144C249.129 258.144 249.899 258.382 250.496 258.858C251.103 259.325 251.439 259.969 251.504 260.79H249.74C249.712 260.435 249.544 260.132 249.236 259.88C248.928 259.628 248.522 259.502 248.018 259.502C247.561 259.502 247.187 259.619 246.898 259.852C246.609 260.085 246.464 260.421 246.464 260.86C246.464 261.159 246.553 261.406 246.73 261.602C246.917 261.789 247.15 261.938 247.43 262.05C247.71 262.162 248.093 262.283 248.578 262.414C249.222 262.591 249.745 262.769 250.146 262.946C250.557 263.123 250.902 263.399 251.182 263.772C251.471 264.136 251.616 264.626 251.616 265.242C251.616 265.737 251.481 266.203 251.21 266.642C250.949 267.081 250.561 267.435 250.048 267.706C249.544 267.967 248.947 268.098 248.256 268.098ZM260.569 263.954C260.569 264.243 260.551 264.505 260.513 264.738H254.619C254.666 265.354 254.895 265.849 255.305 266.222C255.716 266.595 256.22 266.782 256.817 266.782C257.676 266.782 258.283 266.423 258.637 265.704H260.359C260.126 266.413 259.701 266.997 259.085 267.454C258.479 267.902 257.723 268.126 256.817 268.126C256.08 268.126 255.417 267.963 254.829 267.636C254.251 267.3 253.793 266.833 253.457 266.236C253.131 265.629 252.967 264.929 252.967 264.136C252.967 263.343 253.126 262.647 253.443 262.05C253.77 261.443 254.223 260.977 254.801 260.65C255.389 260.323 256.061 260.16 256.817 260.16C257.545 260.16 258.194 260.319 258.763 260.636C259.333 260.953 259.776 261.401 260.093 261.98C260.411 262.549 260.569 263.207 260.569 263.954ZM258.903 263.45C258.894 262.862 258.684 262.391 258.273 262.036C257.863 261.681 257.354 261.504 256.747 261.504C256.197 261.504 255.725 261.681 255.333 262.036C254.941 262.381 254.708 262.853 254.633 263.45H258.903ZM261.608 264.108C261.608 263.333 261.767 262.647 262.084 262.05C262.411 261.453 262.849 260.991 263.4 260.664C263.96 260.328 264.576 260.16 265.248 260.16C265.855 260.16 266.382 260.281 266.83 260.524C267.287 260.757 267.651 261.051 267.922 261.406V260.286H269.532V268H267.922V266.852C267.651 267.216 267.283 267.519 266.816 267.762C266.349 268.005 265.817 268.126 265.22 268.126C264.557 268.126 263.951 267.958 263.4 267.622C262.849 267.277 262.411 266.801 262.084 266.194C261.767 265.578 261.608 264.883 261.608 264.108ZM267.922 264.136C267.922 263.604 267.81 263.142 267.586 262.75C267.371 262.358 267.087 262.059 266.732 261.854C266.377 261.649 265.995 261.546 265.584 261.546C265.173 261.546 264.791 261.649 264.436 261.854C264.081 262.05 263.792 262.344 263.568 262.736C263.353 263.119 263.246 263.576 263.246 264.108C263.246 264.64 263.353 265.107 263.568 265.508C263.792 265.909 264.081 266.217 264.436 266.432C264.8 266.637 265.183 266.74 265.584 266.74C265.995 266.74 266.377 266.637 266.732 266.432C267.087 266.227 267.371 265.928 267.586 265.536C267.81 265.135 267.922 264.668 267.922 264.136Z"
          fill="#555770"
        />
        <rect x="482" y="234" width="34" height="48" fill="url(#paint4_linear_3346_193067)" />
        <rect width="34" height="48" transform="matrix(-1 0 0 1 34 230)" fill="url(#paint5_linear_3346_193067)" />
      </g>
      <defs>
        <filter
          id="filter0_i_3346_193067"
          x="298.834"
          y="103.881"
          width="82.8398"
          height="101.84"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.99" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_193067" />
        </filter>
        <filter
          id="filter1_i_3346_193067"
          x="296.554"
          y="18"
          width="87.3999"
          height="5.32031"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.57" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.23 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_193067" />
        </filter>
        <filter
          id="filter2_i_3346_193067"
          x="133.226"
          y="103.881"
          width="82.8398"
          height="101.84"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.99" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_193067" />
        </filter>
        <filter
          id="filter3_i_3346_193067"
          x="130.946"
          y="18"
          width="87.3999"
          height="5.32031"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.57" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.23 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_193067" />
        </filter>
        <filter
          id="filter4_i_3346_193067"
          x="215.101"
          y="104.014"
          width="82.8398"
          height="101.84"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.99" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_193067" />
        </filter>
        <linearGradient
          id="paint0_linear_3346_193067"
          x1="340.254"
          y1="157.761"
          x2="340.254"
          y2="211.263"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3346_193067"
          x1="174.646"
          y1="157.761"
          x2="174.646"
          y2="211.263"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3346_193067"
          x1="256.521"
          y1="157.894"
          x2="256.521"
          y2="211.395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3346_193067"
          x1="-85.0002"
          y1="241"
          x2="-85.0002"
          y2="275"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C7DFF9" stop-opacity="0.85" />
          <stop offset="1" stop-color="#DAF1FB" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3346_193067"
          x1="517.5"
          y1="256"
          x2="500.087"
          y2="241.581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3346_193067"
          x1="35.5"
          y1="22"
          x2="18.0867"
          y2="7.58143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_3346_193067">
          <rect width="516" height="278" fill="white" />
        </clipPath>
        <clipPath id="clip1_3346_193067">
          <rect width="553" height="62" fill="white" transform="translate(0 239)" />
        </clipPath>
      </defs>
    </svg>
  );
};
